export default {"src":"/planos/_next/static/media/spark.aca67df2.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};